import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { type LogoutMutationError, useLogout } from '@/entities/authentication/api/generated/api';
import { logout } from '@/entities/session/api/sessionApi';
import { useFormDirtyStore } from '@/shared/stores/form-dirty-store';
import { toast } from '@/shared/ui';

export const useLogoutAction = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useLogout({
    mutation: {
      onSuccess: () => {
        // entities/sessionのlogout()でトークンクリア + キャッシュクリア + セッションクリア
        logout();

        // フォームの編集状態をリセットしてLeavePageAlertのブロックを解除
        useFormDirtyStore.getState().setIsDirty(false);

        toast.success(t('common.messages.logout-success'));

        // ログインページへリダイレクト
        navigate({ to: '/login' });
      },
      onError: (error: LogoutMutationError) => {
        // エラーでもローカル状態はクリアする
        logout();

        // フォームの編集状態をリセットしてLeavePageAlertのブロックを解除
        useFormDirtyStore.getState().setIsDirty(false);

        const message = error.response?.data?.message || t('common.messages.logout-failed');
        toast.error(message);

        navigate({ to: '/login' });
      },
    },
  });
};
